"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// (DA)省份AOP
var _default = exports.default = {
  getList: function getList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/regionAopKpi/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  import: function _import(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/regionAopKpi/import',
      method: 'post',
      data: data
    });
  },
  export: function _export(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/regionAopKpi/export',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  }
};